export function normalizeBotMarkdownLineBreaks(text: string): string {
  const normalized = text.replace(/\r\n/g, '\n').replace(/\\n/g, '\n');

  return normalized.replace(/([^\n])\n(?!\n)/g, '$1  \n');
}

export function normalizeBotMarkdown(text: string): string {
  return normalizeBotMarkdownLineBreaks(text.trim());
}
